<template>
  <div v-if="permissionCheck('Machines','Read')" class="container-fluid">
    <div class="row actions no-print">
      <div class="col-md-3 float-left">
        Home > Settings > Machines
      </div>
      <div class="col-md-9">
        <button v-if="uploadView && permissionCheck('Machines','Read')" class="btn btn-danger float-right" style="margin: 5px;" @click="closeUploadHistory"> <icon name="times"></icon> </button>
        <select v-if="uploadView && permissionCheck('Machines','Read')" v-model="uploadLimit" class="form-control float-right" style="max-width: 140px; float: right; margin-top: 5px;">
          <option :value="100">Last 100 Files</option>
          <option :value="200">Last 200 Files</option>
          <option :value="300">Last 300 Files</option>
          <option :value="400">Last 400 Files</option>
          <option :value="1000000">All Files</option>
        </select>
        <button v-if="!uploadView && permissionCheck('Machines','Read')" class="btn btn-outline-dark float-right" style="margin: 5px;" @click="uploadHistory"><icon name="upload"></icon> Upload History</button>
        <button v-if="!uploadView && adminCheck" class="btn btn-success float-right" style="margin: 5px;" @click="createMachine"><icon name="plus"></icon> Create New Machine</button>
      </div>
    </div>
    <!--------------------------->
    <!-- Machines Listing Page -->
    <!--------------------------->
    <h1 v-if="!selectedMachine && !newMachine && !uploadView" style="text-align: center;"><br/><icon name="cog" scale="5"></icon><br/>Attendance Machines</h1>
    <h1 v-if="uploadView" style="text-align: center;"><br/><icon name="upload" scale="5"></icon><br/>Files Upload History</h1>
    <div  v-if="!selectedMachine && !newMachine && !uploadView"class="col-md-12">
      <div class="row justify-content-center " align="center">
        <div class="col-md-2 col-sm-4 shadows" style="margin: 25px 10px 25px 10px; padding: 15px 5px 15px 5px;" v-for="machine in machines">
          <h6><strong>{{machine.name}}</strong></h6>
          <button v-if="permissionCheck('Machines','Update')" class="btn btn-success" @click="selectMachine(machine)">Upload Files</button>
        </div>
      </div>
      <br/>
    </div>

    <!--------------------------->
    <!-- Uploaded Files History Page -->
    <!--------------------------->
    <div  v-if="uploadView" class="col-md-12">
      <div class="container" style="margin-top: 25px;">
        <div class="col-md-12" style="margin-top: 25px; margin-bottom: 25px;">

        </div>
        <table  class="table table-hover shadows" width="80%;">
          <thead>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center;">Upload Date</th>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center;">Machine Name</th>
          <th scope="col" style="font-size: 12px; background-color: #fffaf0; text-align: center; width: 200px;">File Name</th>
          </thead>
          <tbody>
          <tr v-for="historyFile in uploadedFilesHistory">
            <td align="center">{{$moment(historyFile.date).format('ddd, DD-MM-YYYY, hh:mm A')}}</td>
            <td align="center">{{historyFile.machine}}</td>
            <td align="center">{{historyFile.name}}</td>
          </tr>
          </tbody>

        </table>
      </div>
    </div>

    <!--------------------------->
    <!-- Machines Create Page --->
    <!--------------------------->

    <h1  v-if="newMachine && !selectedMachine && !uploadView" style="text-align: center;"><br/><icon name="cog" scale="5"></icon><br/>Create New Machine<br/>&nbsp;</h1>
    <div  v-if="newMachine && !selectedMachine && !uploadView"class="col-md-12">
      <div class="row justify-content-center " align="center">
        <div class="col-md-6" style="margin-bottom: 25px;">
          <div class="row form-group">
            <div class="col-md-3">
              <strong class="form-control">Machine Name:</strong>
            </div>
            <div class="col-md-6">
              <input :class="{'is-danger-input': machineCreateForm.errors.has('name')}" class="form-control" v-model="machineCreateForm.name" type="text"/>
              <div class="float-left help is-danger" v-if="machineCreateForm.errors.has('name')" v-text="machineCreateForm.errors.get('name')"></div>
            </div>
            <div class="col-md-3">
              <button class="btn btn-success float-right" type="button" @click="saveMachine" style="margin-right: 5px;"><icon name="save"></icon> Create</button>
              <button v-if="newMachine" class="btn btn-danger float-right" @click="closeMachine" type="button" style="margin-right: 5px;"><icon name="times"></icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!--------------------------->
    <!-- Machines Details Page -->
    <!--------------------------->

    <h1  v-if="selectedMachine && !newMachine && !uploadView" style="text-align: center;"><br/><icon name="cog" scale="5"></icon><br/>{{selectedMachine.name}}<br/>&nbsp;</h1>
    <div  v-if="selectedMachine && !newMachine && !uploadView"class="col-md-12">
      <div class="row justify-content-center " align="center">
        <div class="col-md-6" style="margin-bottom: 25px;">
          <div class="row form-group">
            <div class="col-md-3">
              <strong class="form-control">Machine Name:</strong>
            </div>
            <div class="col-md-6">
              <input :class="{'is-danger-input': machineUpdateForm.errors.has('name')}" class="form-control" v-model="machineUpdateForm.name" type="text"/>
              <div class="float-left help is-danger" v-if="machineUpdateForm.errors.has('name')" v-text="machineUpdateForm.errors.get('name')"></div>
            </div>
            <div class="col-md-3">
              <button class="btn btn-success float-right" type="button" @click="updateMachine" style="margin-right: 5px;"><icon name="save"></icon> Update</button>
              <button v-if="newMachine || selectedMachine" class="btn btn-danger float-right" @click="closeMachine" type="button" style="margin-right: 5px;"><icon name="times"></icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h1  v-if="selectedMachine" style="text-align: center;"><br/><icon name="upload" scale="5"></icon><br/>File Upload<br/>&nbsp;</h1>
    <div  v-if="selectedMachine" class="col-md-12">
      <div class="row justify-content-center " align="center">

        <div class="col-md-4" style="margin-bottom: 25px;">
          <!--File Upload Button-->
          <label id="fileDiv">
                <span class="btn btn-primary" style="overflow-y: hidden;"><icon name="paperclip"></icon> Upload Attendance
                    <input multiple style="visibility: hidden; width: 0; height: 0;" type="file" id="file" ref="file" v-on:change="submitFile('attachments/replies')"/>
                </span>
          </label>
          <b-tooltip target="fileDiv" placement="bottom" title="Attachments"></b-tooltip>
          <div class="col-md-auto text-left">
            <table v-if="uploadingFiles.length > 0" class="table table-hover" style="margin-top: 10px;">
              <thead>
              <th scope="col" style="font-size: 12px; background-color: #fffaf0;">File Name</th>
              <th scope="col" style="font-size: 12px; min-width: 175px; background-color: #fffaf0;">File Size</th>
              <th scope="col" style="font-size: 12px; min-width: 140px; background-color: #fffaf0;">Upload Status</th>
              </thead>

              <tbody>

              <tr v-for="filexx in uploadingFiles">
                <td>{{filexx.name}}</td>
                <td>{{getFileSize(filexx.size)}}</td>
                <td>
                  <div v-if="findUploadedFileByName(filexx.name)">
                    <div class="badge badge-success">Uploaded</div>
                  </div>
                  <div v-if="filexx.name !== activeFile.name && !findUploadedFileByName(filexx.name)">
                    <semipolar-spinner :animation-duration="2500" :size="20" :color="'#62a622'" ></semipolar-spinner>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div align="center" v-if="selectedMachine && selectedMachine.totalFiles === 0">There are no attached file for this machine.</div>







  </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'AlertsZone',
        data () {
            return {
                machines: this.$store.getters['machines/getMachines'],
                selectedMachine: null,
                newMachine: null,
                uploadView: false,
                uploadLimit: 100,
                uploadedFilesHistory: [],

                // Attachments
                files: [],
                activeFile: {
                    name: null,
                },
                uploadingFiles: [],
                uploadedFiles: [],
                uploadPercentage: 0,
                uploadedFilesIDs: [],
                uploadBusy: false,
                downloadLink: null,

                machineUpdateForm: new Form({
                    id: null,
                    name: null,
                }),

                machineCreateForm: new Form({
                    name: null,
                }),
            }
        },

        methods: {

            selectMachine(machine){
                this.selectedMachine = machine;
                this.machineUpdateForm.id = machine.id;
                this.machineUpdateForm.name = machine.name;
                this.files = [];
                this.uploadingFiles = [];
                this.uploadedFiles = [];
                this.uploadedFilesIDs = [];
                this.activeFile = null;
                this.uploadBusy = false;
                this.downloadLink = null;

            },
            closeMachine(){
                this.selectedMachine = null;
                this.machineUpdateForm.id = null;
                this.machineUpdateForm.name = null;
                this.newMachine = null;
                this.loadMachines();
                this.machineUpdateForm.onSuccess('');
                this.machineCreateForm.onSuccess('');
            },
            updateMachine(){
                this.$store.dispatch('machines/updateMachine', this.machineUpdateForm)
                    .then(response => {
                        this.machineUpdateForm.onSuccess(response);
                        this.loadSingleMachine(this.selectedMachine.id);
                        this.$snotify.success('Machine Updated');
                    })
                    .catch(error => {
                        this.machineUpdateForm.onFail(error);
                        this.$snotify.error(this.machineUpdateForm.errors.error.message, this.machineUpdateForm.errors.error.title);
                    })

            },
            createMachine(){
                this.newMachine = true;
                this.selectedMachine = null;
            },
            saveMachine(){

                this.$store.dispatch('machines/storeMachine', this.machineCreateForm)
                    .then(response => {
                        this.machineCreateForm.onSuccess(response);
                        this.loadMachines();
                        this.newMachine = false;
                        this.$snotify.success('Machine Saved');
                    })
                    .catch(error => {
                        this.machineCreateForm.onFail(error);
                        this.$snotify.error(this.machineCreateForm.errors.error.message, this.machineCreateForm.errors.error.title);
                    })
            },

            uploadHistory(){
                this.$store.dispatch('machines/fetchUploadHistory', this.uploadLimit)
                    .then(response => {
                        this.uploadedFilesHistory = response;
                        this.uploadView = true;
                    })
            },
            closeUploadHistory(){
                this.uploadView = false;
            },

            clearFileUpload(){
                this.files = [];
            },
            getFileSize(sizeInBytes){
                if(sizeInBytes > 1048576) {
                    let size = sizeInBytes / 1048576;
                    return size.toFixed(1)+' MB';
                } else{
                    if(sizeInBytes > 0) {
                        let size = sizeInBytes / 1024;
                        return size.toFixed(0)+' KB'
                    }
                }
                return '0 KB';
            },
            findUploadedFileByName(name){for (let s of this.uploadedFiles) {if(s.uploadName == name){return s}}},
            findUploadedFileByID(id){for (let s of this.uploadedFiles) {if(s.id == id){return s}}},
            submitFile(directory, imageOnly, maxHeight, maxWidth){
                this.files = this.$refs.file.files;

                this.uploadingFiles = [];
                for(let f of this.files){this.uploadingFiles.push({
                    name: f.name,
                    size: f.size,
                });}

                this.uploadBusy = true;

                if(this.files.length > 0)
                {
                    for(let file of this.files){
                        this.activeFile = file;
                        let formData = new FormData();
                        formData.set('file', file);
                        formData.set('machineID', this.selectedMachine.id);
                        axios.post('/api/attendance/machine_attachment', formData,
                            {
                                onUploadProgress: function( progressEvent ) {
                                    this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                                }.bind(this)
                            })
                            .then(res => {
                                console.log('uploadFiles - File Uploaded Successfully.');
                                this.uploadPercentage = 0;
                                this.uploadedFiles.push(res.data.data)
                                this.uploadPercentage = 0;
                                let fileIndex0 = this.uploadingFiles.findIndex(x => x.name === res.data.data.name)
                                if(fileIndex0 > -1){this.uploadingFiles.splice(fileIndex0, 1)};
                                this.uploadBusy = false;
                                this.activeFile = {name:null};
                                resolve(res.data.data);
                            })
                            .catch(error => {})
                    }
                }

            },

            loadSingleMachine(machineID) {
                // Load Machines
                this.$store.dispatch('machines/fetchSingleMachines', machineID)
                    .then(response => {this.selectMachine(response)})
            },

            loadMachines() {
                // Load Machines
                this.$store.dispatch('machines/fetchMachines')
                    .then(response => {this.machines = this.$store.getters['machines/getMachines'];})
            },

        },

        computed: {
            //
        },

        watch: {
            uploadLimit(newValue, oldValue){
                if(newValue !== oldValue){this.uploadHistory();}
            },
        },

        created() {
            this.loadMachines();
        },

    }
</script>


<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/hr/attendance/machines.vue